/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const canInt = feature.getSettingValue('CANINT');
    const featureId = feature.getID();

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `${project.getCodeLocationStart()}${doneLinks[0].getSourceId()}${project.getCodeLocationEnd()}` : '';
    const links = project.getNodeLinks(feature, 'pat.play');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];

        blocks.push({
            location: 'SIMULATOR_OS',
            blockType: BlockType.CODE,
            id: 'let_pat_canint',
            template: `
let patCanInt = ${canInt};`,
        });

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
patCanInt = ${canInt};
if (simulator.context.pat.pattern === '' || patCanInt === 1) {
    simulator.updateContext("pat", {
        pattern: ${project.getNodeParameter(link, 'patternstring')},
        canInt: patCanInt,
    })
}
${doneBlock}`,
        });
    }


    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        id: 'pat_init_context',
        template: `
this.updateContext("pat", {
    pattern: '',
})`,
    });

    return blocks;
};
